var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { addFeatureFlag, listFeatureFlags, removeFeatureFlag, } from '@/clients/admin';
import { Component, Vue } from 'vue-property-decorator';
import Tooltip from '@/components/Tooltip.vue';
let AccountManagementFeatureFlagsTab = class AccountManagementFeatureFlagsTab extends Vue {
    constructor() {
        super(...arguments);
        this.options = [
            {
                value: 'export_btn_info_set_page',
                label: 'Opção de exortação dentro da pagina de infoset',
                description: 'Habilita a renderização do botão de exportação dentro da pagina da lista',
            },
            {
                value: 'enrichment_whatsapp',
                label: 'Enriquecimento de Whatsapp',
                description: 'Habilita a renderização do botão de whatsapp na pagina da lista, ao lado das opções de validação de email e telefone',
            },
            {
                value: 'beta_ai_extension',
                label: 'Kanbam gerado pelo LLM',
                description: 'Habilita a renderização do botão para pagina de kanbam gerado pelo llm na pagina da lista, ao lado das opções de kanbam e lista',
            },
            {
                value: 'agent_10x',
                label: 'Botão de Agente 10X',
                description: 'Habilita a renderização do botão de comunicação com a extensão do agente 10x na pagina da lista, ao lado das opções de validação de email e telefone',
            },
            {
                value: 'whatsapp_sender',
                label: 'decizap-enviador',
                description: 'Habilita a renderização do botão que abre o aplicativo do enviador de mensagens do decizap, na pagina "Meus Apps", abaixo do "Gravador"',
            },
            {
                value: 'crm_atlas',
                label: 'CRM Atlas',
                description: 'Habilita a funcionalidade do CRM Atlas para a conta',
            },
            {
                value: 'new_export_modal',
                label: 'Novo modal de exportação de listas',
                description: 'Abre o novo modal de exportação servido pelo atlas-reborn (iframe) ao exportar uma lista. Sem a flag, a conta continua no modal de exportação antigo',
            },
            {
                value: 'atlas_v4',
                label: 'Nova versão (V4) — Busca e Empresa',
                description: 'Habilita a nova experiência do Atlas (atlas-reborn): página de busca e detalhes da empresa. Sem a flag, o usuário vê as telas antigas',
            },
            {
                value: 'atlas_v4_convite',
                label: 'Nova versão (V4) — Convite (opt-in)',
                description: 'Exibe o modal de apresentação da nova versão nas telas antigas, permitindo que a própria conta ative o V4 quando quiser. Sem esta flag a conta não vê nenhum convite. Use para liberar a nova versão aos poucos, conta a conta',
            },
            {
                value: 'new_settings_page',
                label: 'Nova página de configurações (painel do usuário)',
                description: 'Exibe o painel do usuário (/user) na nova versão, servido pelo atlas-reborn via iframe. Sem a flag, a conta continua no painel de configurações antigo (V3)',
            },
            {
                value: 'new_infosets_page',
                label: 'Nova listagem de listas (Minhas listas)',
                description: 'Exibe a listagem de listas (a tela inicial, "/") na nova versão, servida pelo atlas-reborn via iframe. Sem a flag, a conta continua na listagem antiga (V3). A página de uma lista específica (kanban) tem flag própria',
            },
            {
                value: 'new_infoset_kanban',
                label: 'Nova tela de campanha (kanban da lista)',
                description: 'Exibe a página de uma lista (/infosets/:id, o kanban) na nova versão, servida pelo atlas-reborn via iframe. Sem a flag, a conta continua na campanha antiga (V3), independente da flag da listagem',
            },
            {
                value: 'decizap_decisor',
                label: 'WhatsApp do decisor (Decizap)',
                description: 'Exibe o botão "Solicitar WhatsApp" no card de cada decisor, na aba Decisores do detalhe da empresa (atlas-reborn), quando a empresa é aberta a partir de uma busca ou lista. Consome créditos somente quando o número é encontrado',
            },
            {
                value: 'company_email_validation',
                label: 'Validar e-mails na ficha da empresa',
                description: 'Exibe o botão "Validar e-mails" na aba Contatos do detalhe da empresa (atlas-reborn), que valida todos os e-mails da empresa e dos decisores. Sem a flag, a ficha só mostra o status de validação que já existe',
            },
        ];
        this.loading = true;
        this.currentFeatureFlags = [];
        this.accountId = '';
    }
    mounted() {
        this.accountId = this.$store.getters['admin/get_selected_account'];
        this.listFeatureFlags();
    }
    async listFeatureFlags() {
        try {
            const response = await listFeatureFlags(this.accountId);
            this.currentFeatureFlags = response.data;
            this.loading = false;
        }
        catch (e) {
            console.log(e);
        }
    }
    async addFeature(option) {
        this.loading = true;
        try {
            const response = await addFeatureFlag({
                flag: option.value,
                account_id: this.accountId,
            });
            this.currentFeatureFlags = response.data.feature_flags;
        }
        catch (e) {
            console.log(e);
        }
        this.loading = false;
    }
    async removeFeature(option) {
        this.loading = true;
        try {
            const response = await removeFeatureFlag({
                flag: option.value,
                account_id: this.accountId,
            });
            this.currentFeatureFlags = response.data.feature_flags;
        }
        catch (e) {
            console.log(e);
        }
        this.loading = false;
    }
    get currentFeatureFlagsFormatted() {
        return this.currentFeatureFlags
            .map(flag => this.options.find(opt => opt.value == flag))
            .filter((opt) => opt !== undefined);
    }
    get featureFlagsNotYetAdded() {
        return this.options.filter(opt => !this.currentFeatureFlags.includes(opt.value));
    }
};
AccountManagementFeatureFlagsTab = __decorate([
    Component({
        components: { Tooltip },
    })
], AccountManagementFeatureFlagsTab);
export default AccountManagementFeatureFlagsTab;
